import { withHook } from 'utils/withHook';
import { useCompetitionsFeedState } from 'containers/CompetitionsFeed/logic/useCompetitionsFeedState';
import { CompetitionsFeedView } from 'containers/CompetitionsFeed/view/CompetitionsFeedView';

export const CompetitionsFeed = withHook(useCompetitionsFeedState)(
  CompetitionsFeedView
);
